import type { GetFactoringExtensionPendingAccountDetail } from 'lib/api/extension/factoring/types';
import type { Dispatch, SetStateAction } from 'react';
import { createContext, useContext } from 'react';

type IExtensionFormContext = {
  extension: any;
  setExtension: Dispatch<SetStateAction<any>>;
  document: any;
  setDocument: Dispatch<SetStateAction<any>>;
  searched: boolean;
  setSearched: Dispatch<SetStateAction<boolean>>;
  canModifyParams: boolean;
  setCanModifyParams: Dispatch<SetStateAction<boolean>>;
  canChangeArrearRate: boolean;
  noIvaComision: number | null;
  edit: boolean;
  canEdit: boolean;
  submitExtension: () => Promise<void>;
  pendingAccounts: GetFactoringExtensionPendingAccountDetail[];
};

export const ExtensionFormContext = createContext<IExtensionFormContext | null>(
  null,
);

export const useExtensionFormContext = (): IExtensionFormContext => {
  const ctx = useContext(ExtensionFormContext);

  if (ctx == null) {
    throw new Error(
      'useExtensionFormContext debe usarse dentro de un ExtensionFormContext.Provider',
    );
  }

  return ctx;
};
